import publicBuill from '../../../../components/reimbursement/js/publicBuill'
import axios from 'axios'
import moment from 'moment'
import Decimal from 'decimal.js'
export default {
  name: 'oa_ccFybxd',
  data() {
    return {
      user: {
        groupName: localStorage.getItem('groupName'),
        companyTitle: localStorage.getItem('company').split(',')[0]
      },
      date1: [],
      jkrArr: [],
      ccFybxd: {
        bmbm: localStorage.getItem('deptNo'),
        bmmc: localStorage.getItem('groupName'),
        lrr: localStorage.getItem('userName'),
        lrrId: localStorage.getItem('userNo'),
        rejected: '0',
        state: '0'
      },
      optionsFyBxUser: [],
      /* 编辑需要数据 */
      jeDx: '',
      rq: '',
      files: [],
      saveBtn: true
    }
  },
  created() {
    publicBuill.setThis(this)
    publicBuill.getFyBxUser().then()
  },
  mounted() {
    if (localStorage.getItem('userNo') === '51544') {
      this.user.companyTitle = '吴忠仪表检修服务分公司'
      this.user.companyId = '10'
    } else {
      publicBuill.companyNameQuery(localStorage.getItem('company')).then(res => {
        if (!this.user.companyTitle || this.user.companyTitle === '' || !this.user.companyId || this.user.companyId === '') {
          this.saveBtn = true
          this.$message.error('公司信息获取失败，请联系管理员！！！')
        } else {
          this.saveBtn = false
        }
      })
    }
    this.rq = publicBuill.dateToString(new Date())
  },
  methods: {
    dateChange() {
      const time1 = this.date1[0]
      const time2 = this.date1[1]
      this.ccFybxd.ccrq1 = moment(time1).format('YYYY-MM-DD HH:mm:SS')
      this.ccFybxd.ccrq2 = moment(time2).format('YYYY-MM-DD HH:mm:SS')
      const day = Math.abs(time1.getTime() - time2.getTime())
      this.$set(this.ccFybxd, 'ts', Math.floor(day / (24 * 3600 * 1000)) + 1)
    },
    jkrChange(event) {
      let jkrName = ''
      let jkrid = ''
      for (let i = 0; i < event.length; i++) {
        const jkr = event[i]
        const itemArr = this.optionsFyBxUser.filter(item => item.subjectName === jkr)
        if (itemArr.length > 0) {
          jkrid += itemArr[0].subjectCode
          jkrName += itemArr[0].subjectName
        }
        if (i !== event.length - 1) {
          jkrid += ','
          jkrName += ','
        }
      }
      this.ccFybxd.jkr = jkrName
      this.ccFybxd.jkrid = jkrid
    },
    save() {
      this.ccFybxd.companyId = this.user.companyId
      if (!this.ccFybxd.companyId || this.ccFybxd.companyId === '') {
        this.$message.error('公司信息不全，请联系管理员')
        return
      }
      const jeFormat = ['hsbzbz', 'hsbzje', 'zsbzbz', 'zsbzyjzs', 'zsbzje', 'jtbzbz', 'jtbzje']
      for (let j = 1; j < 5; j++) {
        for (let i = 0; i < jeFormat.length; i++) {
          const name = jeFormat[i] + j
          if (!this.ccFybxd[name] || this.ccFybxd[name] === '') {
            this.ccFybxd[name] = 0.00
          }
        }
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$post('/fesback/Ccfybxd/save.z', this.ccFybxd).then(res => {
        if (res.success) {
          this.$message.success(res.message + this.files.length > 0 ? '发票正在上传...' : '')
          if (this.files.length > 0) {
            publicBuill.vatInvoiceUpload(res.data)
          }
          this.resetForm()
        } else {
          this.$message.error(res.message)
        }
        loading.close()
      }).catch(err => {
        loading.close()
        this.$message.error('非预期错误' + err)
      })
    },
    resetForm() {
      this.jkrArr = []
      this.date1 = []
      this.ccFybxd = {
        bmbm: localStorage.getItem('deptNo'),
        bmmc: localStorage.getItem('groupName'),
        lrr: localStorage.getItem('userName'),
        lrrId: localStorage.getItem('userNo'),
        rejected: '0',
        state: '0'
      }
    },
    jeChange(name) {
      const jeName = ['fjf', 'hcf', 'ctqcf', 'jtf', 'lgf', 'xlf', 'dhf', 'hyf', 'qyf', 'qt']
      let jeitem = 0.00
      for (let i = 0; i < jeName.length; i++) {
        const itemName = jeName[i]
        if (this.ccFybxd[itemName] && !Number.isNaN(this.ccFybxd[itemName])) {
          jeitem = Decimal(this.ccFybxd[itemName]).add(Decimal(jeitem)).toNumber()
        }
      }
      this.ccFybxd.clfxj = jeitem
      if (!this.ccFybxd[name]) {
        return
      }
      if (name === 'je') {
        this.jeDx = publicBuill.convertCurrency(this.ccFybxd[name])
      }
      this.ccFybxd[name] = parseFloat(this.ccFybxd[name]).toFixed(2)

    },

    handleRemove(file, fileList) {
      this.files = fileList
    },
    handlePreview(file) {
      const a = document.createElement('a')
      const event = new MouseEvent('click')
      a.target = '_blank'
      a.href = window.URL.createObjectURL(file.raw)
      a.dispatchEvent(event)
    },
    fileChange(file, fileList) {
      this.files = fileList
    },
    vatInvoiceOrc() {
      const formData = new FormData()
      for (let i = 0; i < this.files.length; i++) {
        formData.append(`files[${i}]`, this.files[i].raw)
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios.post('/fesback/invoice/vatInvoiceOcr.z', formData).then(response => {
        const res = response.data
        if (res.success) {
          const invoices = res.data.invoices
          const commodityList = res.data.commodityList
          console.log(invoices)
          console.log(commodityList)
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
        loading.close()
      }).catch(res => {
        this.$message.error('未知异常： ' + res)
        loading.close()
      })
    }
  }
}
